import { API_URL } from "@/mainconfig";

// CH-W54 — banner promo home (publik). domainMiddleware backend menentukan owner dari subdomain.
const actions = {
    async getActiveBanners(_ctx, payload) {
        try {
            const placement = payload?.placement ?? 1;
            const res = await API_URL.get(`/banner/active?placement=${placement}`);
            return res.data?.data ?? [];
        } catch (e) {
            return [];
        }
    },
};

export default { namespaced: true, actions };
